// extracted by mini-css-extract-plugin
export default {"button":"CustomButton_button__a4DjW","small":"CustomButton_small__IFoT-","main":"CustomButton_main__DG+9s","secondary":"CustomButton_secondary__ZXY0g"};